import type { AxiosError } from 'axios'

export class FormError extends Error {
  constructor (message: string, public statusCode?: number, public responseData?: unknown) {
    super(message)
    this.name = 'FormError'
    this.statusCode = statusCode
    this.responseData = responseData

    Object.setPrototypeOf(this, FormError.prototype)
  }

  static fromAxiosError (error: AxiosError): FormError {
    const statusCode = error.response?.status
    const responseData = error.response?.data
    return new FormError(error.message, statusCode, responseData)
  }
}
